import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { DetalleTareaPageComponent } from './modules/admin/detalle-tareas/detalle-tarea.component';
import { DetalleTareasResolver } from './modules/admin/detalle-tareas/detalle-tarea-resolver';
import { GestionesComponent } from './modules/admin/gestiones/gestiones.componente';
import { GestionesResolver } from './modules/admin/gestiones/gestiones.resolver';
import { SearchComponent } from './modules/searchComponents/search.component';
import { SearchResolver } from './modules/searchComponents/search.resolver';
import { RegistroBienCulturalComponent } from './modules/admin/bienes-culturales/registro-bien-cultural/registro-bien-cultural.component';
import { FormBienCulturalComponent } from './modules/admin/bienes-culturales/registro-bien-cultural/form-bien-cultural/form-bien-cultural.component';
import { DetalleBienCulturalComponent } from './modules/admin/bienes-culturales/detalle-bien-cultural/detalle-bien-cultural.component';
import { RegistroBienCulturalResolver } from './modules/admin/bienes-culturales/registro-bien-cultural/registro-bien-culturarl.resolver';
import { DetalleBienCulturalResolver } from './modules/admin/bienes-culturales/detalle-bien-cultural/detalle-bien-cultural.resolver';
import { ListadoBienesCulturalesComponent } from './modules/admin/bienes-culturales/bienes-culturales-list/bienes-culturales-list.component';
import { BienesCulturalesResolver } from './modules/admin/bienes-culturales/bienes-culturales-list/bienes-culturales.resolver';
import { ColeccionistasComponent } from './modules/admin/coleccionistas/coleccionistas.component';
import { DetalleColeccionistaComponent } from './modules/admin/coleccionistas/detalle-coleccionista/detalle-coleccionista.component';
import { DetalleColeccionistaResolver } from './modules/admin/coleccionistas/detalle-coleccionista/detalle-coleccionista.resolver';
import { DetalleDocumentosOficialesComponent } from './modules/admin/documentos-oficiales/detalle-documentos-oficiales/detalle-documentos-oficiales.component';
import { DocumentosOficialesComponent } from './modules/admin/documentos-oficiales/documentos-oficiales/documentos-oficiales.component';
import { DetalleDocumentosResolver } from './modules/admin/documentos-oficiales/detalle-documentos-oficiales/detalle-documentos.resolver';
import { AdministradorDePlantillasComponent } from './modules/admin/documentos-oficiales/Herramientas/administrador-de-plantillas/administrador-de-plantillas.component';
import { AtributosBienCulturalComponent } from './modules/admin/documentos-oficiales/Herramientas/listado-de-atributos-de-bien-cultural/atributos-bien-cultural.component';
import { RolesPermisosComponent } from './modules/admin/administrar/roles-y-permisos.component';
import { ReportesComponent } from './modules/admin/reportes/reportes.component';
import { ActualizarPermisosComponent } from './modules/admin/administrar/actualizar-permisos/actualizar-permisos.component';
import { ActualizarRolResolver } from './modules/admin/administrar/actualizar-permisos/actualizar-permisos.resolver';
import { PermisosGuard } from './core/auth/guards/permisosGuard';
import { Error404Component } from './modules/error404/error404.component';
import { VideoTutorialesComponent } from './modules/video-tutorirales/video-tuturiales.component';


// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    {path: '', pathMatch : 'full', redirectTo: 'example'},

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'home'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')}
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {
                path: 'example', 
                loadChildren: () => import('app/modules/admin/example/example.routes'),
            },
            {
                path: 'home', 
                loadChildren: () => import('app/modules/admin/home/home.module').then(m => m.HomeModule),
                canActivate: [PermisosGuard],
                data: { menu: '/home' }
            },
            {
                path: 'solicitudes', 
                loadChildren: () => import('app/modules/admin/solicitudes/solicitudes.module').then(m => m.SolicitudesModule),
                canActivate: [PermisosGuard],
                data: { menu: '/solicitudes' }
            },
            {
                path: 'usuarios', 
                loadChildren: () => import('app/modules/admin/usuarios/usuarios.module').then(m => m.UsuriosModule),
                canActivate: [PermisosGuard],
                data: { menu: '/usuarios' }
            },
            
            {
                path: 'gestiones', 
                component: GestionesComponent,
                resolve:{gestionesResolver: GestionesResolver},
                canActivate: [PermisosGuard],
                data: { menu: '/gestiones' }
            },
            {
                path: 'gestiones/seccion/:seccion_uuid',
                component: GestionesComponent,
                resolve:{gestionesResolver: GestionesResolver},
                canActivate: [PermisosGuard],
                data: { menu: '/gestiones/seccion' }
            },

            {
                path: 'gestiones/generales', 
                component: GestionesComponent,
                resolve:{gestionesResolver: GestionesResolver},
                canActivate: [PermisosGuard],
                data: { menu: '/gestiones/generales' }
            },

            {
                path: 'search/:value', 
                component: SearchComponent,
                resolve:{searchResolver:SearchResolver},
            },


            // Task Details Page

            {
                path: 'task-details/task/:task_uuid',
                component: DetalleTareaPageComponent,
                resolve: { taskDetailsResolver: DetalleTareasResolver }
            },

            // Bienes Culturales
            {
                path: 'bienes-culturales/registro',
                component: RegistroBienCulturalComponent,
                canActivate: [PermisosGuard],
                data: { menu: 'bienes-culturales/registro'}
            },
            {
                path:'bienes-culturales/registro/seccion/:seccion_uuid',
                component: FormBienCulturalComponent,
                resolve: {RegistroBienCulturalResolver},
            },
            {
                path:'bienes-culturales/detalle/:uu_id',
                component: DetalleBienCulturalComponent,
                resolve: {DetalleBienCulturalResolver},
            },
            {
                path:'bienes-culturales/listado-general',
                component: ListadoBienesCulturalesComponent,
                resolve: {BienesCulturalesResolver},
                canActivate: [PermisosGuard],
                data: { menu: '/bienes-culturales/listado-general' }
            },
            {
                path:'bienes-culturales/seccion/:seccion_uuid',
                component: ListadoBienesCulturalesComponent,
                resolve: {BienesCulturalesResolver},
                canActivate: [PermisosGuard],
                data: { menu: '/bienes-culturales/seccion'}
            },

            {
                path:'coleccionistas',
                component: ColeccionistasComponent,
                canActivate: [PermisosGuard],
                data: { menu: '/coleccionistas'}
            },
            {
                path:'coleccionista/:coleccionistaUuid/:coleccionistaId',
                component:DetalleColeccionistaComponent,
                resolve: {DetalleColeccionistaResolver},
            },

            //Documentos oficiales
            {
                path:'documentos-oficiales',
                component:DocumentosOficialesComponent,
                canActivate: [PermisosGuard],
                data: { menu: '/documentos-oficiales' }
            },
            {
                path:'documentos-oficiales/detalle/:documento_uuid',
                component:DetalleDocumentosOficialesComponent,
                resolve: { DetalleDocumentosResolver },
            },

            {
                path:'Administrador-de-Plantillas',
                component:AdministradorDePlantillasComponent,
                canActivate: [PermisosGuard],
                data: { menu: '/Administrador-de-Plantillas'}
            },
            {
                path:'atributos-bien-cultural',
                component:AtributosBienCulturalComponent,
                canActivate: [PermisosGuard],
                data: { menu: '/atributos-bien-cultural'}
            },
            //Reportes
            {
                path:'reportes/seccion/:seccion_uuid',
                component:ReportesComponent,
                canActivate: [PermisosGuard],
                data: { menu: '/reportes/seccion/:seccion_uuid'}
            },

            //Administrar-Roles y Permisos
            {
                path:'roles-y-permisos',
                component:RolesPermisosComponent,
                canActivate: [PermisosGuard],
                data: { menu: '/roles-y-permisos'}
            },
            {
                path:'roles-y-permisos/rol/:rol_uuid',
                component:ActualizarPermisosComponent, 
                resolve: { ActualizarRolResolver },
            },


            //video tutoriales
            {
                path:'tutoriales',
                component: VideoTutorialesComponent, 
            },

            {
                path:'error404',
                component: Error404Component, 
            },

            {
                path: '**',
                redirectTo: '/error404', // o cualquier página de error o inicio
            },

            


        ]
    }
];
